export default import.meta.ROLLDOWN_FILE_URL_xssBwR3Ikhu9SsYO6gLIMQ